import apiClient from "./api";

export interface QuotationItem {
  product_id: number;
  product_code?: string;
  product_name?: string;
  product_variant_id?: number | null;
  variant_id?: number | null;
  product_type?: string | null;
  unit_price: number;
  price?: number;
  tax_id?: number | null;
  tax?: number;
  discount?: number;
  subtotal?: number;
  quantity: number;
  [key: string]: any;
}

export interface QuotationRecord {
  id?: number;
  reference_no: string;
  customer_id?: number | null;
  customer_name?: string | null;
  warehouse_id?: number | null;
  warehouse_name?: string | null;
  note?: string | null;
  tax?: number;
  discount?: number;
  shipping?: number;
  total?: number;
  grand_total?: number;
  status?: string;
  created_at?: string;
  updated_at?: string;
  attachments?: Array<{
    id?: number;
    file_name?: string;
    file_path?: string;
    path?: string;
  }>;
  items: QuotationItem[];
}

export interface QuotationData {
  customer_id?: number | null;
  customer_code?: string | null;
  customer_name?: string | null;
  warehouse_id?: number | null;
  warehouse_code?: string | null;
  warehouse_name?: string | null;
  branch_id?: number | null;
  branch_code?: string | null;
  branch_name?: string | null;
  biller_id?: number | null;
  biller_code?: string | null;
  biller_name?: string | null;
  reference_no: string;
  note?: string | null;
  tax_id?: number | null;
  tax?: number;
  discount?: number;
  shipping?: number;
  total?: number;
  total_discount?: number;
  total_tax?: number;
  grand_total?: number;
  status?: string;
  property_type?: string | null;
  system_type?: string | null;
  location?: string | null;
  user_id?: number;
  items: QuotationItem[];
}

const quotationService = {
  async createQuotation(data: QuotationData) {
    const response = await apiClient.post("/quotations", data);
    return response.data;
  },
  async getQuotations(params?: any) {
    const response = await apiClient.get("/quotations", { params });
    return response.data;
  },
  async getQuotation(id: number): Promise<QuotationRecord> {
    const response = await apiClient.get(`/quotations/${id}`);
    return response.data.data ?? response.data;
  },
  async updateQuotation(id: number, data: QuotationData) {
    const response = await apiClient.put(`/quotations/${id}`, data);
    return response.data;
  },
  async deleteQuotation(id: number) {
    const response = await apiClient.delete(`/quotations/${id}`);
    return response.data;
  },
  async getNextReference(): Promise<string> {
    const response = await apiClient.get("/quotations/next-reference");
    return response.data.data ?? response.data;
  },
};

export default quotationService;
